"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminInstructorEditLocation = /** @class */ (function () {
    function AdminInstructorEditLocation($state, $stateParams, UsersModel, FlashService, school, instructor, instructorLocations) {
        var _this = this;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.loading = true;
        this.zones = [];
        this.noSectorsSelected = true;
        this.formData = {
            'instructor_id': $stateParams.instructorId,
            'sectors': [],
            'location': null
        };
        this.school = school;
        this.center = {
            lat: this.school.address.lat,
            lng: this.school.address.lng,
            zoom: 34
        };
        this.instructor = instructor;
        this.locations = instructorLocations;
        // set the current location being viewed, this is where the instructor's zones come from
        this.locations.forEach(function (location) {
            if (location.id === parseInt($stateParams.locationId)) {
                _this.formData.location = location;
                _this.location = location;
            }
        });
        this.zones = this.location.zones.map(function (zone) {
            zone.zoneparts = zone.zoneparts.map(_this.parseSector);
            return zone;
        });
        this.formData.sectors = this.instructor.zoneparts.map(this.parseSector);
        this.loading = false;
    }
    AdminInstructorEditLocation.prototype.selectAllSectors = function (zone) {
        var _this = this;
        zone.zoneparts.forEach(function (sector) {
            if (!_this.isSelected(sector)) {
                _this.formData.sectors.push(sector);
            }
            else {
                _this.formData.sectors.splice(_this.formData.sectors.findIndex(function (s) { return s.id === sector.id; }), 1);
            }
        });
    };
    AdminInstructorEditLocation.prototype.parseSector = function (sector) {
        delete sector.geom;
        delete sector.created_at;
        delete sector.updated_at;
        delete sector.pivot;
        return sector;
    };
    AdminInstructorEditLocation.prototype.submit = function (isValid) {
        var _this = this;
        this.submitted = true;
        if (isValid && this.formData.sectors.length > 0) {
            var payload = structuredClone(this.formData);
            var sectors = Array.from(new Set(this.formData.sectors.map(function (sector) { return sector.id; })))
                .map(function (id) { return _this.formData.sectors.find(function (sector) { return sector.id === id; }); });
            payload.sectors = sectors;
            this.UsersModel.editInstructorLocation(payload).then(function (response) {
                _this.FlashService.setMessage({ 'type': 'success', 'message': response.message });
                _this.submitted = false;
                _this.$state.go('drivecoach.admin.instructors.locations', { 'instructorId': _this.instructor.id }, { 'reload': true });
            });
        }
        else {
            this.FlashService.setMessage({ 'type': 'error', 'message': 'Please fill in the form.' });
        }
    };
    AdminInstructorEditLocation.prototype.handleClick = function (sector) {
        var index = this.formData.sectors.findIndex(function (s) { return s.id === sector.id; });
        if (index !== -1) {
            this.formData.sectors.splice(index, 1);
        }
        else {
            this.formData.sectors.push(sector);
        }
    };
    AdminInstructorEditLocation.prototype.isSelected = function (sector) {
        return this.formData.sectors.some(function (s) { return s.id === sector.id; });
    };
    return AdminInstructorEditLocation;
}());
AdminInstructorEditLocation.$inject = ['$state', '$stateParams', 'UsersModel', 'FlashService', 'school', 'instructor', 'instructorLocations'];
exports.default = AdminInstructorEditLocation;
